<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        巡查隐患管理
      </div>
    </div>
    <div class="flex">
      <unitList v-show="!($store.state.user.userInfo.natureId == 2)" @select="getUnit" @getFirst="getOne"></unitList>

      <div class="flex1">
        <div class="common-page common-tool-bar" style="justify-content: end">
          <div >
            <!-- v-hasPermi="['relic:relicInspectionRecords:export']" -->
            <el-button size="small" type="success" @click="outPut" v-hasPermi="['relic:hiddenDanger:export']"> 导出数据</el-button>
            <el-button class="ml10" @click="showDia = true" size="small" type="primary" >
              <!-- v-hasPermi="['safe:record:query']" -->
              查询
            </el-button>
          </div>

        </div>


        <div >
          <div class="common-page common-list">
            <el-table :data="list" class="">
              <!-- <el-table-column
              prop="c_point_number"
              label="巡查点编号"
              align="center"
            >
            </el-table-column> -->
             
              <el-table-column prop="pointName" label="巡查点名称" align="center"> </el-table-column>
              <el-table-column prop="pointAddr" align="center" label="巡查点位置"> </el-table-column>
              <!-- <el-table-column
              prop="c_point_states"
              align="c_point_error"
              label="是否异常"
            >
              isNormal
              <template slot-scope="scope">{{
                $map.isNormal[scope.row.c_point_error]
              }}</template>
            </el-table-column> -->
              <el-table-column prop="pointStatisticsNum" align="center" label="上报次数"> </el-table-column>
               <el-table-column prop="pointErrorDesc" label="巡查结果描述" align="center"> </el-table-column>

              <el-table-column prop="commitName" align="center" label="上报人姓名"> </el-table-column>
              <el-table-column prop="commitTime" align="center" label="最近上报时间">
                <!-- 1:'正常',
        2:'待审核',
        3:'待复核',
        4:'待整改',
        5:'已整改' -->
                <!-- <template slot-scope="scope">
                  <el-button
                    size="mini"
                    plain
                    :type="scope.row.pointStates == 5 ? 'success' : scope.row.pointStates == 4 ? 'danger' : scope.row.pointStates == 3 ? 'primary' : scope.row.pointStates == 2 ?'warning': 'info'"
                  >
                    {{ $map.checkstates[scope.row.pointStates] }}
                  </el-button>
                </template> -->
              </el-table-column>
              <el-table-column label="操作" align="center" width="200px" fixed="right">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/wenlv/inspectionDangerDetail',
                      query: { id: scope.row.id },
                    }"
                    v-if="scope.row.pointStates == 2 || scope.row.pointStates == 3"
                    
                  >
                  <!--  -->
                    <el-button size="mini" type="primary" v-hasPermi="['relic:relicInspectionRecords:updateStatus']">审核</el-button>
                  </router-link>
                  <router-link
                    :to="{
                      path: '/wenlv/inspectionDangerDetail',
                      query: { id: scope.row.id, view: 1 },
                    }"
                    
                  >
                  <!-- v-hasPermi="['safe:record:edit']" -->
                    <el-button size="mini" type="primary" v-hasPermi="['relic:relicInspectionRecords:selectInfoById']">详情</el-button>
                  </router-link>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <el-pagination background layout="prev, pager, next" @current-change="pageChange" :page-size="10" :total="total"> </el-pagination>
        </div>

      </div>
    </div>
    <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
      <fm-generate-form  :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"> </fm-generate-form>

      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
        <el-button @click="cancle" size="small">重置</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
// import {getCompanyList,switchCompany} from '../../api/company'
import unitList from '@/components/unitList1';
export default {
  data() {
    return {
      // 检查点状态 1-5 正常 待审核 待复核 待整改 已整改
      list: [],
      list1: [],

      
      params: {
        // page: 1,
        commitName: '',
        pointStates: '',
        pointAddr: '',
        companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
        pointError: '',
        startTime: '',
        pointNum: this.$route.query.id || '',
        commitTime: '',
        endTime: '',
         pageSize: 10,
        pageNum: 1,
      },
    //   params1: {
    //     companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
    //     startTime: '',
    //     endTime: '',
    //     inspectionType: '',
    //     nickName: '',
    //     pointAddr: '',
    //     startTime: '',
    //     state: '',
    //     pageSize: 10,
    //     pageNum: 1,
    //   },
      cpNum: '',
      id: this.$route.query.id,
      nowIndex: 0,
      outPutForm: {},
      total: 0,
      total1: 0,
      showDia: false,
      showSearch: true,
      searchForm: this.$route.query.id ? this.$getForm('recordSearch1') : this.$getForm('recordSearch'),
      searchForm1: this.$route.query.id ? this.$getForm('recordwwSearch1') : this.$getForm('recordwwSearch'),

      editData: {},
      editData1: {},

      remoteFuncs1: {
        _this: this,
        getNumber(resolve) {
          var _this = this._this;
          _this.$post('/xuncha/selectxcnum').then((res) => {
            resolve(res.data);
          });
        },
        getPerson(resolve) {
          var _this = this._this;
          _this.$get('/relic/relicInspectionRecords/commitNameList?companyNum='+this.cpNum).then((res) => {
            resolve(res.data);
          });
        },
      },
      remoteFuncs: {
        _this: this,
        getNumber(resolve) {
          var _this = this._this;
          _this.$post('/xuncha/selectxcnum').then((res) => {
            resolve(res.data);
          });
        },
        getPerson(resolve) {
          var _this = this._this;
          _this.$get('/relic/relicInspectionRecords/commitNameList?companyNum='+_this.cpNum).then((res) => {
            console.log(res,4444);
            resolve(res.data);
          });
        },
      },
    };
  },
  //  beforeRouteEnter(to, from, next) {

  //   next(vm => {
  //        if(from.name==='/safe/recorddetail'){
  //           vm.getDatas()
  //           }
  //     //因为当钩子执行前，组件实例还没被创建
  //     // vm 就是当前组件的实例相当于上面的 this，所以在 next 方法里你就可以把 vm 当 this 来用了。
  //     console.log(vm);//当前组件的实例
  //   });
  // },
  created() {
    // this.getDatas();
  },
  components: {
    unitList,
  },
  watch: {
    cpNum() {
      this.params.companyNum = this.cpNum;
      this.params.pageNum = 1;
    //   this.params1.companyNum = this.cpNum;
    //   this.params1.pageNum = 1;
      this.getDatas();
    },
  },
  methods: {
    getDatas() {
        this.getList();

    },
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },

    cancle() {
      // this.showDia = false;
      this.resetSearch();
    },
    //导出
    outPut() {
    //   var obj = { ...this.params, ...this.outPutForm };
    //   var { commitTime, companyNum, pointAddr, pointError, startTime, pointNum, commitName, endTime } = obj;
    //   var url = `${this.$config.apiUrl}/relic/relicInspectionRecords/export?companyNum=${companyNum}&commitTime=${commitTime}&pointAddr=${pointAddr}&pointError=${pointError}&pointNum=${pointNum}&commitName=${commitName}&startTime=${startTime}&endTime=${endTime}`;
    //   window.location = url;

            this.$get(
        "/relic/relicInspectionRecords/exportHiddenDanger",
        this.params
      ).then((res) => {
        // console.log(this.download)
         this.download(res.msg)
      });
    //   this.downLoadExcel('/inspection/wenwuInspectionAppMain/export', this.params1);
    },
    // output1() {
    //   // this.$get(
    //   //   "/culturalRelics/wenwuBasicInformation/export",
    //   //   this.params
    //   // ).then((res) => {
    //   //   console.log(this.download)
    //   //    this.download(res.msg)
    //   // });
    //   this.downLoadExcel('/inspection/wenwuInspectionAppMain/export', this.params1);
    // },
    changeStatus(id, status) {
      switchCompany({ id, status })
        .then((res) => {
          this.getDatas();
        })
        .catch((err) => {});
    },

    getList() {
      this.$get('/relic/relicInspectionRecords/getHiddenDangerList', this.params).then((res) => {
        console.log(res,11111);
        this.list = res.rows;
        this.total = res.total;
      });
    },

    pageChange(val) {
      this.params.pageNum = val;
    //   this.params1.pageNum = val;
      this.getDatas();
    },
    searchSubmit() {
 
        this.$refs.searchForm
          .getData()
          .then((data) => {
            this.params = { ...this.params, ...data };
            log(this.params,333333333)

            if (this.id) {
              this.params.pointNum = this.id;
            }
            this.params.page = 1;

            this.getDatas();
            this.outPutForm = this.params;
            this.showDia = false;
          })
          .catch((e) => {});
 
    },
    getOne(v) {
      this.cpNum = v;
      this.getList()
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
        this.$refs.searchForm.reset();
    

      this.params = {
        page: 1,
        c_point_name: '',
        c_point_addr: '',
        companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
        c_point_error: '',
        start_time: '',
        c_point_number: this.$route.query.id || '',
        end_time: '',
        ...this.$refs.searchForm.models,
      };
    //   (this.params1 = {
    //     companyNum: this.cpNum || this.$store.state.user.company.cCompanyNum,
    //     startTime: '',
    //     endTime: '',
    //     inspectionType: '',
    //     nickName: '',
    //     pointAddr: '',
    //     startTime: '',
    //     state: '',
    //     pageSize: 10,
    //     pageNum: 1,
    //   }),
        this.getDatas();
      this.outPutForm = {};
    },
  },
};
</script>

<style scoped></style>
